import React from "react";

export default function UserEdit() {
  return <div>Edit</div>;
}
